/* ------------------------------------------------------
   Collector reviews
   Desktop (>=990px): plain 3-column CSS grid (no Swiper).
   Mobile (<990px): Swiper slider using the theme's Swiper.
------------------------------------------------------ */
(function () {
  var DESKTOP = 990;

  function setup(root) {
    if (!root) return;
    var el = root.querySelector('[data-reviews-swiper]');
    if (!el) return;

    var instance = null;

    function isMobile() {
      return window.innerWidth < DESKTOP;
    }

    function create() {
      if (instance) return;
      if (!window.Swiper) {
        window.setTimeout(create, 100);
        return;
      }
      instance = new window.Swiper(el, {
        slidesPerView: 1.27,
        spaceBetween: 24,
        watchOverflow: true,
        breakpoints: {
          750: { slidesPerView: 2, spaceBetween: 20 }
        }
      });
    }

    function destroy() {
      if (instance) {
        instance.destroy(true, true);
        instance = null;
      }
    }

    function sync() {
      if (isMobile()) {
        create();
      } else {
        destroy();
      }
    }

    sync();

    var raf;
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(sync);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-reviews]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    setup(e.target.querySelector('[data-reviews]'));
  });
})();